import {
  FETCHING_SHARES_COUNT,
  FETCHING_SHARES_COUNT_SUCCEEDED,
  FETCHING_SHARES_COUNT_FAILED,
} from "constants/actionTypes";

const initState = {
  count: {
    all: {
      fetching: false,
      total: 0,
      error: null,
    },
  },
};

function sharesReducer(state = initState, action) {
  switch (action.type) {
    case FETCHING_SHARES_COUNT: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: true, total: 0, error: null },
        },
      });
    }

    case FETCHING_SHARES_COUNT_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: action.payload, error: null },
        },
      });
    }

    case FETCHING_SHARES_COUNT_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return Object.assign({}, state, {
        ...state,
        count: {
          ...state.count,
          all: { fetching: false, total: 0, error: error },
        },
      });
    }
    default:
      return state;
  }
}

export { sharesReducer };
